module.exports = __webpack_public_path__ + "static/media/quoraLogo.507c3a23.png";